import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import { Icon } from '@livable/saas-react-components';
import useStyles from './styles';
export const WarningDialog = _ref => {
  let isOpen = _ref.isOpen,
    title = _ref.title,
    subtitle = _ref.subtitle,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    _ref$cancelLabel = _ref.cancelLabel,
    cancelLabel = _ref$cancelLabel === void 0 ? 'Cancel' : _ref$cancelLabel,
    _ref$confirmLabel = _ref.confirmLabel,
    confirmLabel = _ref$confirmLabel === void 0 ? 'Save changes' : _ref$confirmLabel,
    _ref$confirmColor = _ref.confirmColor,
    confirmColor = _ref$confirmColor === void 0 ? 'warning' : _ref$confirmColor,
    children = _ref.children;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onClose: onCancel,
    maxWidth: false,
    classes: {
      paper: classes.paper
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.headerText
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.titleRow
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "alert",
    color: confirmColor
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.title
  }, title)), !!subtitle && /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "text.secondary",
    className: classes.subtitle
  }, subtitle)), /*#__PURE__*/React.createElement(IconButton, {
    onClick: onCancel,
    className: classes.close
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  }))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogContent, {
    className: classes.content
  }, children), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions, {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    className: classes.cancelButton,
    onClick: onCancel
  }, cancelLabel), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: confirmColor,
    className: classes.confirmButton,
    onClick: onConfirm
  }, confirmLabel)));
};